import { useCallback, useEffect, useMemo, useState } from 'react';
import type { Language } from './translations';
import { I18nContext, type I18nContextValue } from './useI18n';
import { createI18nValue } from './createI18nValue';
import { getLanguageOverride, getVisitorLanguage, storeLanguage } from './language';

export function I18nProvider({ children }: { children: React.ReactNode }) {
  // Язык самого посетителя: выбор → браузер → русский. Принудительный язык публичной
  // карты (`PublicLanguageScope`) сюда не попадает — он живёт в своём поддереве.
  const [language, setLanguageState] = useState<Language>(getVisitorLanguage);

  useEffect(() => {
    // Эффект родителя идёт ПОСЛЕ эффектов детей: страница с закреплённым языком уже выставила
    // свой `lang`, и затирать его языком посетителя нельзя.
    document.documentElement.lang = getLanguageOverride() ?? language;
  }, [language]);

  const setLanguage = useCallback((nextLanguage: Language) => {
    storeLanguage(nextLanguage);
    setLanguageState(nextLanguage);
  }, []);

  const value = useMemo<I18nContextValue>(
    () => createI18nValue(language, setLanguage),
    [language, setLanguage],
  );

  return <I18nContext value={value}>{children}</I18nContext>;
}
